export const setFocusOn = (id: string, delay = 50) => {
  setTimeout(() => {
    document.getElementById(id)?.focus();
  }, delay);
};